// admin.solucoder.ai — Start: Anmeldung oder die Oberfläche.
//
// Erst `/auth/me`: ohne Sitzung die Anmeldeseite. Mit Sitzung wird der
// Katalog geladen (Features, Integrationen, Lizenz-Vorlagen — jedes Formular
// braucht ihn), dann steht die Oberfläche.

import { createRoot } from "react-dom/client";
import { ApiError, get, setUnauthorizedHandler } from "./api/client";
import { fetchCatalog, keys } from "./api/queries";
import { createQueryClient } from "./api/query-client";
import type { LoginInfo, Me } from "./api/types";
import { App } from "./app/app";
import { Login } from "./app/login";
import { errorText } from "./lib/labels";
import { toast } from "./ui/toaster";

const container = document.getElementById("app");
if (!container) throw new Error("#app fehlt");
const root = createRoot(container);

async function boot(): Promise<void> {
  let me: Me;
  try {
    me = await get<Me>("/auth/me");
  } catch (err) {
    root.render(<Login info={err instanceof ApiError ? (err.body as LoginInfo | null) : null} />);
    return;
  }
  // Ab hier heißt ein 401 „Sitzung abgelaufen" — nicht mehr „nicht angemeldet".
  setUnauthorizedHandler(() => {
    toast("Sitzung abgelaufen — bitte neu anmelden", "error");
    setTimeout(() => window.location.reload(), 1500);
  });
  const client = createQueryClient();
  client.setQueryData(keys.me, me);
  await client.fetchQuery({ queryKey: keys.catalog, queryFn: fetchCatalog, staleTime: Infinity });
  root.render(<App client={client} me={me} />);
}

boot().catch((err: unknown) => {
  root.render(<div className="pf-login"><div className="pf-login__card"><p>{errorText(err)}</p></div></div>);
});
